import tw from "twin.macro";

export const PrimaryLink = tw.a`cursor-pointer font-bold text-[#0049AC] border-b-2 border-transparent transition duration-300`;
